module.exports = __webpack_public_path__ + "static/puddle-d71860b396faae652648d8a0ebc11d15.jpg";